import React from 'react';

import { OrdCreate, OrdEdit } from '@ragu-components/ord-components';
import { Resources } from '@ragu-components/ord-resources';

import { UserForm } from './UserForm';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { UserRead } from '@ragu-components/ord-types';

const UserList = React.lazy(async () => import('./UserList'));

export const userResource: OrdResourceProps = {
  key: Resources.users,
  name: Resources.users,
  list: <UserList />,
  create: (
    <OrdCreate>
      <UserForm />
    </OrdCreate>
  ),
  edit: (
    <OrdEdit
      transform={(data, context) => {
        const previousData = context?.previousData;
        if (data.photo === undefined) return data;
        if (previousData !== undefined && data.photo === previousData.photo) {
          const { photo, ...rest } = data as Record<string, unknown>;
          return rest;
        }
        return data;
      }}
    >
      <UserForm />
    </OrdEdit>
  ),
  options: {},
  recordRepresentation: (user: UserRead): string => `${user.firstname} ${user.lastname}`,
};
